import { render, staticRenderFns } from "./editCate.vue?vue&type=template&id=69250d76&scoped=true&"
import script from "./editCate.vue?vue&type=script&lang=js&"
export * from "./editCate.vue?vue&type=script&lang=js&"
import style0 from "./editCate.vue?vue&type=style&index=0&id=69250d76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69250d76",
  null
  
)

export default component.exports